export const splitDocumentDescription = (documentDescription?: string): { description: string; documentNumber: string } => {
  if (!documentDescription) {
    return {
      description: '',
      documentNumber: '',
    };
  }

  const documentSeparator = '#';
  const index = documentDescription.indexOf(documentSeparator);

  if (index === -1) {
    return {
      description: documentDescription.trim(),
      documentNumber: '',
    };
  }

  const description = documentDescription.slice(0, index).trim();
  const documentNumber = documentDescription.slice(index + documentSeparator.length).trim();

  return { description, documentNumber };
};
